module.exports = __webpack_public_path__ + "static/img/SearchDetailLogout4.a78255f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailLogout4.png
// module id = 740
// module chunks = 0